// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HJT4","title":"Header_title__1kPVd","side":"Header_side__2tKJC"};